import Dynamsoft from "dynamsoft-javascript-barcode";
Dynamsoft.BarcodeReader.engineResourcePath = "/DBR-JS-7.3.0/distr";
// Please visit https://www.dynamsoft.com/CustomerPortal/Portal/TrialLicense.aspx to get a trial license
Dynamsoft.BarcodeReader.productKeys =
  "f0068MgAAAKgVBUBFcefYw2KPWnhe8SwunHMWthirs+JlcbK0jqIiHeYIcp30o0cyrfzG+nA4K7cL/S9ZoocVWnACto21FAg=";
Dynamsoft.BarcodeReader._bUseFullFeature = false; // Control of loading min wasm or full wasm.
export default Dynamsoft;
